import { useEffect } from 'react'
import BottomSheetContent from '../../../components/BottomSheetComponents/BottomSheetContent'
import { TaxHarvestingBottomSheetName, trackTaxHarvestingBottomSheetLoaded } from '../tracking/taxHarvestingTracking'

type ElssAlternativesBottomSheetProps = {
  onDismiss: () => void
}

export function ElssAlternativesBottomSheet({ onDismiss }: ElssAlternativesBottomSheetProps) {
  useEffect(() => {
    trackTaxHarvestingBottomSheetLoaded(TaxHarvestingBottomSheetName.ElssAlternatives)
  }, [])
  return (
    <BottomSheetContent
      logoSvg={<BookQuestionIcon />}
      heading="Alternative funds for rebalancing ELSS Investments"
      onDismiss={onDismiss}
    >
      <div className="flex flex-col gap-4 text-[14px] font-[400] leading-[150%] text-[#6A6E6E]">
        <p>
          Given ELSS funds offer no tax benefits in the new tax regime, we recommend you to switch
          to <span className="font-[500] text-[#232323]">top-ranked Flexi Cap or Contra funds</span> for
          similar returns and risk profile.
        </p>
        <ul className="list-disc pl-5 space-y-[2px] pt-1">
          <li>Follow the same steps shown in your recommendation to switch funds.</li>
          <li>
            All <span className="font-[500] text-[#232323]">Flexi Cap & Contra funds</span> ranked 1, 2,
            and 3 are strong performers and suitable for switching.
          </li>
          <li>
            If you prefer a specific Fund House, you&apos;re free to pick any among the Top 3 ranked
            funds in the same category.
          </li>
        </ul>
      </div>
    </BottomSheetContent>
  )
}

export const BookQuestionIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
      <path d="M19.0322 14.2488C19.0322 13.2663 19.3236 12.3059 19.8694 11.489C20.4153 10.6721 21.1911 10.0353 22.0988 9.65937C23.0065 9.2834 24.0053 9.18504 24.9689 9.37669C25.9325 9.56837 26.8176 10.0415 27.5123 10.7362C28.2071 11.4309 28.6802 12.316 28.8718 13.2797C29.0635 14.2433 28.9651 15.2421 28.5892 16.1498C28.2132 17.0575 27.5765 17.8333 26.7596 18.3791C25.9427 18.925 24.9822 19.2163 23.9998 19.2163V20.8722" stroke="#232323" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M23.9998 27.7027C23.5426 27.7027 23.1719 27.332 23.1719 26.8748C23.1719 26.4176 23.5426 26.0469 23.9998 26.0469" stroke="#232323" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M23.9998 27.7027C24.457 27.7027 24.8277 27.332 24.8277 26.8748C24.8277 26.4176 24.457 26.0469 23.9998 26.0469" stroke="#232323" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M42.2142 45.5285H10.7532C9.43572 45.5285 8.17218 45.0053 7.2406 44.0737C6.30902 43.1421 5.78564 41.8784 5.78564 40.561C5.78564 39.2436 6.30902 37.9798 7.2406 37.0483C8.17218 36.1167 9.43572 35.5934 10.7532 35.5934H38.9025C39.7808 35.5934 40.6233 35.2444 41.2442 34.6235C41.8652 34.0025 42.2142 33.1601 42.2142 32.2818V5.78825C42.2142 4.90993 41.8652 4.0676 41.2442 3.44653C40.6233 2.82547 39.7808 2.47656 38.9025 2.47656H10.7532C9.45834 2.4761 8.2145 2.98124 7.28663 3.88438C6.35873 4.78752 5.82019 6.01725 5.78564 7.31163V40.4285" stroke="#232323" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M38.9023 35.5938V45.5288" stroke="#232323" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
